import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="project-selector"
export default class extends Controller {
  static targets = ["select"]

  // When project dropdown changes, submit the form to load new project
  submitForm(event) {
    const form = event.target.closest('form')
    if (form) {
      form.requestSubmit()
    }
  }

  // When a project folder title is clicked, select it
  selectFolder(event) {
    const projectFolderLi = event.target.closest('li.project_folder')
    if (!projectFolderLi) return

    const match = projectFolderLi.id.match(/project_folder_(\d+)/)
    if (!match) return

    const projectFolderId = match[1]

    fetch(`/my/folders/${projectFolderId}/select_simple`, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'text/vnd.turbo-stream.html'
      }
    })
    .then(response => response.text())
    .then(html => Turbo.renderStreamMessage(html))
  }
}
